<!-- src/app/components/navigation/navigation.component.html -->
<div class="container" [ngClass]="userRole === 'SUPPLIER' ? 'command-center' : 'borrower-portal'">
  <div class="head" [ngClass]="{'collapsed': !sidenavExpand}">
    <div class="logo" (click)="toggleSidebar()">
      <img [src]="userRole === 'SUPPLIER' ? './assets/images/transend-logo-light.png' : './assets/images/transend-logo-dark.png'">
    </div>
    @if (sidenavExpand) {
      <div class="close-sidenav" (click)="toggleSidebar()">
        <mat-icon class="close-sidenav" svgIcon="nav_collapse"></mat-icon>
      </div>
    }
  </div>



  <!-- Iterate over each menu link -->
  @for (menu of menus; track menu) {
    <div class="nav-item">
      @if (menu.allowedRole === 'ALL' || menu.allowedRole === userRole) {
        <!-- If this is NOT the settings menu, use (click) to menu url -->
        @if (menu.url !== settingsUrl) {
          <div
            class="nav-link"
            (click)="navigateTo(menu.url)"
            routerLinkActive="nav-link-active">
            @if (menu.icon) {
              <a class="nav-icon">
                <mat-icon>{{ menu.icon }}</mat-icon>
              </a>
            }
            @if (sidenavExpand) {
              <a class="nav-title">
                {{ menu.title }}
              </a>
            }
          </div>
        } @else {
          <div class="nav-link" (click)="openSettingsModal()">
            @if (menu.icon) {
              <a class="nav-icon">
                <mat-icon>{{ menu.icon }}</mat-icon>
              </a>
            }
            @if (sidenavExpand) {
              <a class="nav-title">
                {{ menu.title }}
              </a>
            }
          </div>
        }
        <!-- Else, if it is the settings menu, use a click event -->
      }
    </div>
  }
</div>
